import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';
import image from '../assets/tech-image2.jpg';

// ✅ Background Setup
const SignupContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* ✅ Desktop: Right side */
  align-items: center;
  background-image: url(${image});
  background-size: cover;
  background-position: center;
  height: 100vh;
  color: #D9D9D9;
  position: relative;
  min-height: 500px;
  padding-right: 10%;  

  @media (max-width: 768px) {
    justify-content: center; /* ✅ Mobile: Center */
    align-items: center;
    padding-right: 0;
    padding: 20px;
    height: auto;
  }
`;

// ✅ Dark Overlay
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
`;

// ✅ Form Box (Perfect Alignment)
const FormContainer = styled.div`
  background: #D9D9D9;
  padding: 20px;
  border-radius: 15px;
  width: 370px;
  position: relative;
  z-index: 1;
  color: black;
  box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.8);
  text-align: center;

  @media (max-width: 768px) {
    width: 85%;
    margin-top: 50px;
  }

  @media (max-width: 480px) {
    width: 85%;
    padding: 15px;
  }
`;

// ✅ Input Box (Responsive)
const Input = styled.input`
  width: 95%;
  padding: 10px;
  margin-top: 6px;
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid #aaa;
  background-color: #f9f9f9;
  color: #333;
  font-size: 15px;

  &:focus {
    border-color: #0072ff;
    box-shadow: 0 0 6px rgba(0, 114, 255, 0.5);
    outline: none;
  }

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 12px;
  }
`;

// ✅ Label (Left Align)
const Label = styled.label`
  display: block;
  text-align: left;
  margin-top: 10px;
  font-size: 16px;
  color: #333;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const RegisterLink = styled.p`
  margin-top: 20px;
  font-size: 15px;

  a{
    color: #0072ff; 
    font-weight: bold;
  }
`;

// ✅ Submit Button (Aligned & Responsive)
const SubmitButton = styled.button`
  background: #F19F4D;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 5px;
  margin-top: 10px;
  width: 101%;
  font-size: 19px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.8s;

  &:hover {
    background: linear-gradient(90deg, #4484CE, #F9CF00);
  }

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 14px;
  }
`;

// ✅ Left Side Text
const LeftText = styled.div`
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translateY(-50%);
  font-size: 60px;
  font-weight: bold;
  color: white;
  z-index: 2;

  @media (max-width: 768px) {
    font-size: 40px;
    left: 50%;
    top: 10%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    justifyContent: center;
    margin-top: 15px;
  }
`;

// ✅ Register Component
const Register = () => {

  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleRegister = () => {
    if (username.trim() === '' || password.trim() === '' || confirmPassword.trim() === '') {
      alert("Please fill out all fields.");
      return;
    }
    
    if (password !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    localStorage.setItem("registeredUsername", username);
    localStorage.setItem("registeredPassword", password);

    alert("Registration successful!");
    navigate("/login"); // Navigate to login page after registration
  };

  return (
    <>
      <SignupContainer>
        <Overlay />
        <LeftText>Join Us!!</LeftText>
        <FormContainer>
          <h2 style={{ fontSize: '30px', fontWeight: 'bold', textAlign: 'center' }}>Register</h2>
          
          <Label>Username</Label>
          <Input type="text" placeholder="Enter your username" value={username} onChange={(e) => setUsername(e.target.value)} />
          
          <Label>Password</Label>
          <Input type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} />
          
          <Label>Confirm Password</Label>
          <Input type="password" placeholder="Confirm your password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
          
          <SubmitButton onClick={handleRegister}>Register</SubmitButton>

          <RegisterLink>Already have an account? <Link to="/login">Log In Here</Link></RegisterLink>
        </FormContainer>
      </SignupContainer>
    </>
  );
};

export default Register;
